const BLOG_TRANSLATION_LOADERS = {
  tr: () => import('../data/i18n/blogPosts.tr.js'),
  es: () => import('../data/i18n/blogPosts.es.js'),
  fr: () => import('../data/i18n/blogPosts.fr.js'),
  de: () => import('../data/i18n/blogPosts.de.js'),
  it: () => import('../data/i18n/blogPosts.it.js'),
  id: () => import('../data/i18n/blogPosts.id.js'),
  th: () => import('../data/i18n/blogPosts.th.js'),
  bn: () => import('../data/i18n/blogPosts.bn.js'),
  hi: () => import('../data/i18n/blogPosts.hi.js'),
  pt: () => import('../data/i18n/blogPosts.pt.js')
};

const BLOG_TRANSLATION_EXPORTS = {
  tr: 'BLOG_POST_TRANSLATIONS_TR',
  es: 'BLOG_POST_TRANSLATIONS_ES',
  fr: 'BLOG_POST_TRANSLATIONS_FR',
  de: 'BLOG_POST_TRANSLATIONS_DE',
  it: 'BLOG_POST_TRANSLATIONS_IT',
  id: 'BLOG_POST_TRANSLATIONS_ID',
  th: 'BLOG_POST_TRANSLATIONS_TH',
  bn: 'BLOG_POST_TRANSLATIONS_BN',
  hi: 'BLOG_POST_TRANSLATIONS_HI',
  pt: 'BLOG_POST_TRANSLATIONS_PT'
};

export const loadBlogTranslations = async (language = 'en') => {
  const loader = BLOG_TRANSLATION_LOADERS[language];
  if (!loader) return {};
  const module = await loader();
  return module?.[BLOG_TRANSLATION_EXPORTS[language]] || module?.default || {};
};

export default loadBlogTranslations;
